import anchorNavigation from './Main.vue';

export default anchorNavigation;
